import { useUIStore } from '@/store/uiStore';
import React from 'react';

interface MainContentProps {
  children: React.ReactNode;
  className?: string;
}

export const MainContent: React.FC<MainContentProps> = ({
  children,
  className
}) => {
  const { currentView } = useUIStore();

  return (
    <main
      className={`flex-1 bg-background min-h-0 ${
        currentView === 'editor' 
          ? 'overflow-hidden h-full' 
          : 'overflow-auto px-4'
        } ${className || ''}`}
      data-view={currentView}
    >
      {currentView === 'editor' ? (
        // Editor view gets full width and height without container constraints
        <div className="h-full w-full flex flex-col">
          {children}
        </div>
      ) : (
        // Other views can have container constraints
        <div className="h-full w-full max-w-7xl mx-auto">
          {children}
        </div>
      )}
    </main>
  );
}; 